import { z } from "zod";

import type { InferenceModelType } from "./models.model";

/**
 * This is the source of truth for the embedding models that we support.
 *
 * If you add a new model, you will need to:
 * 1) Update any dependant code (all of this should be type-checked based on EmbeddingModelType).
 * 2) Update the website models content, if necessary, using the tooling in @kuzco/website-scripts (ask Sean if you need help).
 *
 * Note: EMBEDDING_MODELS must be a subset of INFERENCE_MODELS. This is enforced at compile time.
 */
export const EMBEDDING_MODELS = ["qwen/qwen3-embedding-4b"] as const;

export const EmbeddingModelSchema = z.enum(EMBEDDING_MODELS);

export type EmbeddingModelType = z.infer<typeof EmbeddingModelSchema>;

export const isEmbeddingModel = (
  model: InferenceModelType,
): model is EmbeddingModelType => {
  return EMBEDDING_MODELS.includes(model as EmbeddingModelType);
};
